import { QUALITY_BANDS } from "../../trainer/quality.ts";
import type { HistoryEntry } from "../../trainer/session.ts";

export function MovesPanel({ history }: { history: HistoryEntry[] }) {
  const pairs: Array<{ num: number; white?: HistoryEntry; black?: HistoryEntry }> = [];
  for (const entry of history) {
    const num = Math.ceil(entry.ply / 2);
    let pair = pairs.find((p) => p.num === num);
    if (!pair) {
      pair = { num };
      pairs.push(pair);
    }
    if (entry.ply % 2 === 1) pair.white = entry;
    else pair.black = entry;
  }

  return (
    <details
      className="move-history"
      hidden={history.length === 0 ? true : undefined}
      id="historyWrap"
    >
      <summary className="move-history-head">
        <span className="history-title">Moves so far</span>
        <span className="history-count">{pairs.length}</span>
      </summary>
      <ol className="history-annotated" id="historyAnnotated">
        {pairs.map((pair) => (
          <li key={pair.num}>
            <span className="hist-num">{pair.num}.</span>
            <span>{pair.white?.san || "…"}</span>
            {pair.white?.qualityBand ? (
              <span className={`quality-band band-inline band-${pair.white.qualityBand}`}>
                {QUALITY_BANDS[pair.white.qualityBand].short}
              </span>
            ) : null}
            <span>
              {pair.black?.san || ""}
              {pair.black?.qualityBand ? (
                <span className={`quality-band band-inline band-${pair.black.qualityBand}`}>
                  {QUALITY_BANDS[pair.black.qualityBand].short}
                </span>
              ) : null}
            </span>
          </li>
        ))}
      </ol>
    </details>
  );
}
